let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gjmIC")).then(() => parcelRequire('guB6Y'));